// The radio's vote (docs/APP_REFERENCE.md "Radio"): the listeners pick the next track's style, one of three
// (site/js/audio/radio.js voteOptions, the show's style first). These are the rules both sides keep: the page
// (site/js/app.js, site/js/ui/radio-vote.js) and the worker (worker/vote.js imports this file), so they can't drift.

export const OPTIONS = 3;
export const CLOSE_LEAD_MS = 20000;   // a vote closes this long before its track starts, so the winner reaches every page first
export const OPEN_MS = 60000;         // the card shows a vote from this long before it closes
export const VOTE_CAP = 5;            // a page's votes: 5 at once,
export const VOTE_EVERY_MS = 2000;    // then one every 2 s (past that the worker strikes, site/js/live/live.js never gets there)
const HOUR_MS = 3600000;
const AHEAD_MS = 10 * 60000;          // a vote is for the track after the one playing: its close is never further ahead

/**
 * A vote as a page sends it, { h, i, at, k } (the slot's hour and index, when it starts in whole epoch ms, and the
 * option), cleaned: whole numbers, i a slot index an hour can have, `at` inside hour h, k one of the options. Else null.
 */
export function cleanVote(v) {
  if (!v || typeof v !== 'object' || Array.isArray(v)) return null;
  const { h, i, at, k } = v;
  if (![h, i, at, k].every(Number.isSafeInteger)) return null;
  if (i < 0 || i > 63 || k < 0 || k >= OPTIONS || at < h * HOUR_MS || at >= (h + 1) * HOUR_MS) return null;
  return { h, i, at, k };
}

/** Whether a vote for the track starting at `at` can be cast at `now`: before it closes, and not too far ahead. */
export const voteOpen = (at, now) => now < at - CLOSE_LEAD_MS && at - CLOSE_LEAD_MS - now <= AHEAD_MS;
